window.anvil.block('product-carousel', el => {
    const sliderEl = el.querySelector('.slider');

	window.gsap.from('.product-carousel-animate', {
		y: '100%',
		opacity: 0,
		duration: 0.8,
		ease: 'power3.out',
		scrollTrigger: {
			trigger: '.product-carousel-trigger',
			start: 'top 80%',
			end: 'bottom 80%',
			toggleActions: 'play none none none',
		}
	});

    if (sliderEl) {
        const slider = new Swiper(sliderEl, {
            loop: false,
			slidesPerView: 1,
            allowTouchMove: false,
			spaceBetween: 20,
            navigation: {
                prevEl: el.querySelector('.js-prev'),
                nextEl: el.querySelector('.js-next'),
            },
			breakpoints: {
				320: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				}
			}
        });

		const tabs = el.querySelectorAll('.js-tab');
		const slides = el.querySelectorAll('.swiper-slide');
		tabs && tabs.forEach(tab => {
			tab.addEventListener('click', () => {
				const category = tab.getAttribute('data-category');

				slides.forEach(slide => {
					if (category === 'all' || slide.getAttribute('data-categories').includes(category)) {
						slide.style.display = 'flex';
					} else {
						slide.style.display = 'none';
					}
				});

				slider.update();

				el.querySelectorAll('.js-tab').forEach(t => t.classList.remove('active'));
				tab.classList.add('active');

				const visibleItems = [...el.querySelectorAll('.swiper-slide')]
					.filter(elem => elem.offsetParent !== null); // only visible

				visibleItems.forEach((elem, i) => {
					elem.classList.remove('first', 'second', 'third');

					if ((i + 1) % 3 === 1) {
						elem.classList.add('first');
					} else if ((i + 1) % 3 === 2) {
						elem.classList.add('second');
					} else {
						elem.classList.add('third');
					}
				});
			});
		});

		window.gsap.from('.product-carousel-card-animate', {
			y: '100%',
			opacity: 0,
			duration: 0.8,
			ease: 'power3.out',
			scrollTrigger: {
				trigger: '.product-carousel-card-trigger',
				start: 'top 80%',
				end: 'bottom 80%',
				toggleActions: 'play none none none',
			}
		});
    }
});
